import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const VolunteerList = () => {
  const [list, setList] = useState([]);
  const [selectedVolunteer, setSelectedVolunteer] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    axios
      .get("https://bntserver.bntfoundation.com/VolunteerApplicationsGet.php")
      .then((res) => {
        setList(res.data);
      })
      .catch(() => {
        toast.error("Failed to fetch data");
      });
  };

  const renderBadge = (text, type = "primary") => (
    <span className={`badge bg-${type} text-capitalize`}>{text}</span>
  );

  const renderBoolean = (val) => {
    const isYes = val === 1 || val === "1" || val === true || val === "yes";
    return (
      <span className={`badge ${isYes ? "bg-success" : "bg-danger"}`}>
        {isYes ? "Yes" : "No"}
      </span>
    );
  };

  return (
    <div className="container-fluid py-4">
      <ToastContainer />

      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="mb-0">Volunteer Applications</h2>
        <button className="btn btn-outline-primary btn-sm" onClick={fetchData}>
          Refresh List
        </button>
      </div>

      <div className="card shadow-sm border-0">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0">
              <thead className="bg-light">
                <tr>
                  <th className="ps-4">Full Name</th>
                  <th>Contact Info</th>
                  <th>Availability</th>
                  <th>Duration</th>
                  <th>Applied On</th>
                  <th className="text-end pe-4">Actions</th>
                </tr>
              </thead>

              <tbody>
                {list.length > 0 ? (
                  list.map((item, index) => {
                    const formattedDate = new Date(item.created_at).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    });

                    return (
                      <tr key={item.id || index}>
                        <td className="ps-4">
                          <div className="fw-bold">{item.full_name}</div>
                          <small className="text-muted text-uppercase">ID: {item.id}</small>
                        </td>
                        <td>
                          <div className="small">{item.email}</div>
                          <div className="small text-muted">{item.phone_number}</div>
                        </td>
                        <td>
                          <div className="mb-1">{renderBadge(item.availability_type, "info")}</div>
                          <div className="small text-muted text-truncate" style={{ maxWidth: "150px" }}>
                            {item.selected_days?.join(", ")}
                          </div>
                        </td>
                        <td>
                          {item.duration_type === "short_term" ? (
                            <div>
                              {renderBadge("Short Term", "warning")}
                              <div className="small text-muted mt-1" style={{ fontSize: '0.75rem' }}>
                                {item.start_date} to {item.end_date}
                              </div>
                            </div>
                          ) : (
                            renderBadge("Ongoing", "success")
                          )}
                        </td>
                        <td className="small">{formattedDate}</td>
                        <td className="text-end pe-4">
                          <button
                            className="btn btn-sm btn-primary px-3 shadow-sm"
                            onClick={() => {
                              setSelectedVolunteer(item);
                              setIsModalOpen(true);
                            }}
                          >
                            Details
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-5 text-muted">
                      No applications found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* 🔥 MODAL */}
      {isModalOpen && selectedVolunteer && (
        <div className="modal d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.6)", zIndex: 1050 }}>
          <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header bg-dark text-white py-3">
                <h5 className="modal-title d-flex align-items-center text-white">

                  Volunteer Application Detail
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setIsModalOpen(false)}
                ></button>
              </div>

              <div className="modal-body p-0 bg-light">
                <div className="p-4">
                  <div className="row g-4">
                    {/* Left Column: Summary */}
                    <div className="col-lg-4">
                      <div className="card border-0 shadow-sm mb-4">
                        <div className="card-body p-4 text-center">
                          <div className="rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px', fontSize: '2rem' }}>
                            {selectedVolunteer.full_name.charAt(0)}
                          </div>
                          <h4 className="mb-1">{selectedVolunteer.full_name}</h4>
                          <p className="text-muted small mb-3">{selectedVolunteer.email}</p>
                          <div className="d-flex justify-content-center gap-2">
                            {renderBadge(selectedVolunteer.availability_type, "primary")}
                            {selectedVolunteer.duration_type === "short_term" ? renderBadge("Short Term", "warning") : renderBadge("Ongoing", "success")}
                          </div>
                        </div>
                        <div className="card-footer bg-white border-top-0 p-4 pt-0">
                          <hr className="mt-0 mb-4 opacity-10" />
                          <div className="mb-3">
                            <label className="text-muted small d-block mb-1 text-uppercase fw-bold ls-1">Phone Number</label>
                            <div className="fw-medium">{selectedVolunteer.phone_number}</div>
                          </div>
                          <div className="mb-3">
                            <label className="text-muted small d-block mb-1 text-uppercase fw-bold ls-1">Full Address</label>
                            <div className="fw-medium small">{selectedVolunteer.address}</div>
                          </div>
                          <div className="mb-0">
                            <label className="text-muted small d-block mb-1 text-uppercase fw-bold ls-1">Police Check Required?</label>
                            <div>{renderBoolean(selectedVolunteer.police_check)}</div>
                          </div>
                        </div>
                      </div>

                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-white fw-bold border-0 pt-4 pb-2">
                          Availability Schedule
                        </div>
                        <div className="card-body pt-0">
                          <div className="mb-3">
                            <label className="text-muted small d-block mb-2">Available Days</label>
                            <div className="d-flex flex-wrap gap-2">
                              {selectedVolunteer.selected_days?.map(day => (
                                <span key={day} className="px-2 py-1 bg-white border rounded small fw-medium">{day}</span>
                              ))}
                            </div>
                          </div>
                          <div className="mb-0">
                            <label className="text-muted small d-block mb-2">Time Slots</label>
                            <div className="d-flex flex-wrap gap-2">
                              {selectedVolunteer.time_slots?.map(slot => (
                                <span key={slot} className="px-2 py-1 bg-white border rounded small fw-medium text-primary">{slot}</span>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Right Column: Detailed Info */}
                    <div className="col-lg-8">
                      <div className="card border-0 shadow-sm mb-4">
                        <div className="card-header bg-white fw-bold py-3 text-primary d-flex align-items-center">
                          <i className="bi bi-file-earmark-text me-2"></i>
                          Interest & Motivation
                        </div>
                        <div className="card-body p-4">
                          <div className="mb-4">
                            <label className="text-muted small fw-bold text-uppercase d-block mb-2">Areas of Interest</label>
                            <div className="p-3 bg-light rounded text-dark fs-6" style={{ borderLeft: '4px solid #0d6efd' }}>
                              {selectedVolunteer.work_interest}
                            </div>
                          </div>

                          <div className="row g-4">
                            <div className="col-md-6">
                              <label className="text-muted small fw-bold text-uppercase d-block mb-2">Why volunteer?</label>
                              <p className="small text-secondary lh-base mb-0">{selectedVolunteer.volunteer_reason}</p>
                            </div>
                            <div className="col-md-6">
                              <label className="text-muted small fw-bold text-uppercase d-block mb-2">Why this organization?</label>
                              <p className="small text-secondary lh-base mb-0">{selectedVolunteer.organization_interest}</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row g-4 mb-4">
                        <div className="col-md-6">
                          <div className="card border-0 shadow-sm h-100">
                            <div className="card-header bg-white fw-bold pt-3 border-0">
                              Skills & Experience
                            </div>
                            <div className="card-body">
                              <div className="mb-3">
                                <label className="text-muted small d-block font-monospace">SKILLS</label>
                                <div className="small text-dark">{selectedVolunteer.skills}</div>
                              </div>
                              <div className="mb-3">
                                <label className="text-muted small d-block font-monospace">EXPERIENCE</label>
                                <div className="small text-dark">{selectedVolunteer.experience || "None"}</div>
                              </div>
                              <div className="mb-0 text-black">
                                <label className="text-muted small d-block font-monospace">CERTIFICATIONS</label>
                                <div className="small text-dark">{selectedVolunteer.certifications}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="card border-0 shadow-sm h-100">
                            <div className="card-header bg-white fw-bold pt-3 border-0">
                              References
                            </div>
                            <div className="card-body p-0">
                              <ul className="list-group list-group-flush">
                                {selectedVolunteer.applicant_references?.map((ref, i) => (
                                  <li key={i} className="list-group-item border-0 px-4 py-3 bg-transparent">
                                    <div className="fw-bold small">{ref.name}</div>
                                    <div className="text-muted" style={{ fontSize: '0.75rem' }}>{ref.phone} | {ref.email}</div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card border-0 shadow-sm mb-4 bg-danger-subtle">
                        <div className="card-header bg-transparent fw-bold pt-3 border-0 text-danger">
                          Emergency & Medical
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-7 border-md-end border-danger-subtle">
                              <label className="text-muted small d-block mb-2 text-uppercase">Emergency Contact</label>
                              <div className="d-flex align-items-center mb-2">
                                <i className="bi bi-telephone-outbound me-2 text-danger"></i>
                                <span className="fw-bold text-dark">{selectedVolunteer.emergency_contact_name}</span>
                              </div>
                              <div className="small text-dark ps-4">
                                <div className="mb-1"><strong>Relation:</strong> {selectedVolunteer.emergency_contact_relation}</div>
                                <div><strong>Phone:</strong> {selectedVolunteer.emergency_contact_phone}</div>
                              </div>
                            </div>
                            <div className="col-md-5 mt-3 mt-md-0">
                              <label className="text-muted small d-block mb-2 text-uppercase">Medical Notes</label>
                              <div className="p-2 border border-danger-subtle bg-white rounded small text-danger fw-medium">
                                {selectedVolunteer.medical_conditions || "No conditions reported."}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Agreement Bar */}
                      <div className="card border-0 shadow-sm bg-success-subtle overflow-hidden">
                        <div className="card-body p-0">
                          <div className="d-flex align-items-stretch">
                            <div className="bg-success px-1"></div>
                            <div className="p-3 w-100">
                              <div className="row align-items-center">
                                <div className="col-md-8">
                                  <div className="small fw-bold text-success mb-1">AGREEMENT SIGNED</div>
                                  <div className="small text-secondary">Digitally signed and agreed to all policies by <strong>{selectedVolunteer.signature_name}</strong></div>
                                </div>
                                <div className="col-md-4 text-md-end mt-2 mt-md-0">
                                  <div className="small text-muted mb-1">DATED</div>
                                  <div className="fw-bold text-dark">{selectedVolunteer.agreement_date}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer bg-white py-3 shadow-sm border-top">
                <button
                  type="button"
                  className="btn btn-link text-secondary text-decoration-none me-auto"
                  onClick={() => setIsModalOpen(false)}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="btn btn-primary px-4 ms-2"
                  onClick={() => setIsModalOpen(false)}
                >
                  Close Details
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VolunteerList;